var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusBoxOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plus-box-outline_1_",
    "data-name": "plus-box-outline (1)",
    d: "M17.222,17.222V4.778H4.778V17.222H17.222M17.222,3A1.778,1.778,0,0,1,19,4.778V17.222A1.778,1.778,0,0,1,17.222,19H4.778A1.778,1.778,0,0,1,3,17.222V4.778A1.777,1.777,0,0,1,4.778,3H17.222M10.111,6.556h1.778v3.556h3.556v1.778H11.889v3.556H10.111V11.889H6.556V10.111h3.556Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBoxOutline);
export default __webpack_public_path__ + "static/media/plus_box_outline.6e84de6b60f088bbf08dcbca9691c46f.svg";
export { ForwardRef as ReactComponent };